(function () {
  var S = window.LUNGX_SETTINGS || {};
  var e = React.createElement;
  var useState = React.useState;
  var useEffect = React.useEffect;
  var useRef = React.useRef;

  var GOLD = "#C9A96A";

  var css = "" +
    "#lungx-root{background:#101418;color:#e8e6e1;font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Helvetica,Arial,sans-serif;min-height:100vh;-webkit-font-smoothing:antialiased}" +
    "#lungx-root *{box-sizing:border-box;margin:0;padding:0}" +
    ".lx-wrap{max-width:1180px;margin:0 auto;padding:0 20px}" +
    ".lx-header{position:sticky;top:0;z-index:50;background:rgba(16,20,24,0.85);backdrop-filter:blur(14px);border-bottom:1px solid rgba(255,255,255,0.06)}" +
    ".lx-header-in{display:flex;align-items:center;justify-content:space-between;height:64px}" +
    ".lx-logo{font-size:1.15rem;font-weight:700;letter-spacing:0.14em;cursor:pointer}" +
    ".lx-logo span{color:" + GOLD + "}" +
    ".lx-nav{display:flex;gap:26px;font-size:0.88rem;color:#9aa4ae}" +
    ".lx-nav a{cursor:pointer;transition:color 0.25s}" +
    ".lx-nav a:hover{color:" + GOLD + "}" +
    ".lx-cartbtn{position:relative;cursor:pointer;background:none;border:1px solid rgba(255,255,255,0.14);color:#e8e6e1;border-radius:999px;padding:8px 18px;font-size:0.85rem;transition:border-color 0.25s}" +
    ".lx-cartbtn:hover{border-color:" + GOLD + "}" +
    ".lx-cartcount{position:absolute;top:-7px;right:-7px;background:" + GOLD + ";color:#101418;font-size:0.68rem;font-weight:700;border-radius:50%;width:19px;height:19px;display:flex;align-items:center;justify-content:center}" +
    ".lx-hero{position:relative;overflow:hidden;text-align:center;padding:120px 20px 140px;background:linear-gradient(180deg,#101418 0%,#0e1a26 55%,#102336 100%)}" +
    ".lx-hero h1{font-size:clamp(2.2rem,5.5vw,4rem);font-weight:600;letter-spacing:-0.02em;line-height:1.12}" +
    ".lx-hero h1 span{color:" + GOLD + "}" +
    ".lx-hero p{margin:20px auto 0;max-width:560px;color:#9aa4ae;font-size:1.12rem;line-height:1.6}" +
    ".lx-cta{display:inline-block;margin-top:36px;padding:15px 44px;border-radius:999px;background:" + GOLD + ";color:#101418;font-weight:600;cursor:pointer;border:none;font-size:1rem;transition:transform 0.3s,box-shadow 0.3s}" +
    ".lx-cta:hover{transform:translateY(-2px);box-shadow:0 12px 32px rgba(201,169,106,0.35)}" +
    ".lx-usps{margin-top:46px;display:flex;gap:28px;justify-content:center;flex-wrap:wrap;color:#9aa4ae;font-size:0.88rem}" +
    ".lx-bubble{position:absolute;bottom:-50px;border-radius:50%;background:radial-gradient(circle at 35% 30%,rgba(255,255,255,0.35),rgba(255,255,255,0.05) 60%,transparent);pointer-events:none;animation-name:lx-rise;animation-timing-function:linear;animation-iteration-count:infinite}" +
    ".lx-bubble-in{width:100%;height:100%;border-radius:50%;animation-name:lx-wobble;animation-timing-function:ease-in-out;animation-iteration-count:infinite;animation-direction:alternate}" +
    "@keyframes lx-rise{0%{transform:translateY(0);opacity:0}8%{opacity:0.7}100%{transform:translateY(-115vh);opacity:0}}" +
    "@keyframes lx-wobble{0%{transform:translateX(-8px)}100%{transform:translateX(8px)}}" +
    ".lx-section{padding:95px 0}" +
    ".lx-title{text-align:center;font-size:2rem;font-weight:600}" +
    ".lx-sub{text-align:center;color:#9aa4ae;margin:10px 0 56px}" +
    ".lx-grid3{display:grid;grid-template-columns:repeat(3,1fr);gap:16px;align-items:stretch}" +
    ".lx-card{background:#151b22;border:1px solid rgba(255,255,255,0.06);border-radius:20px;padding:30px 18px;text-align:center;position:relative;display:flex;flex-direction:column;transition:transform 0.35s,border-color 0.35s}" +
    ".lx-card:hover{transform:translateY(-6px);border-color:rgba(201,169,106,0.4)}" +
    ".lx-card-hero{border:1.5px solid " + GOLD + ";transform:scale(1.045);box-shadow:0 20px 55px rgba(0,0,0,0.5)}" +
    ".lx-card-hero:hover{transform:scale(1.045) translateY(-6px)}" +
    ".lx-badge{position:absolute;top:-13px;left:50%;transform:translateX(-50%);background:" + GOLD + ";color:#101418;font-size:0.72rem;font-weight:700;padding:5px 16px;border-radius:999px;white-space:nowrap}" +
    ".lx-pname{font-size:1.08rem;font-weight:600;margin-top:8px}" +
    ".lx-ptag{color:#9aa4ae;font-size:0.8rem;margin-top:4px}" +
    ".lx-price{font-size:1.7rem;font-weight:600;color:" + GOLD + ";margin:16px 0 2px}" +
    ".lx-compare{color:#707a84;text-decoration:line-through;font-size:0.85rem}" +
    ".lx-feats{list-style:none;margin:18px 0;text-align:left;font-size:0.85rem;color:#9aa4ae;flex:1}" +
    ".lx-feats li{padding:6px 0;border-bottom:1px solid rgba(255,255,255,0.05)}" +
    ".lx-scarce{font-size:0.75rem;color:#e0b25c;margin-bottom:12px}" +
    ".lx-buy{display:block;width:100%;padding:13px;border-radius:12px;border:1px solid " + GOLD + ";background:transparent;color:" + GOLD + ";font-weight:600;cursor:pointer;font-size:0.9rem;transition:background 0.3s,color 0.3s}" +
    ".lx-buy:hover{background:" + GOLD + ";color:#101418}" +
    ".lx-buy-solid{background:" + GOLD + ";color:#101418}" +
    ".lx-grid4{display:grid;grid-template-columns:repeat(4,1fr);gap:16px}" +
    ".lx-acc{background:#151b22;border:1px solid rgba(255,255,255,0.06);border-radius:16px;padding:24px 16px;text-align:center;transition:transform 0.3s}" +
    ".lx-acc:hover{transform:translateY(-4px)}" +
    ".lx-acc-icon{font-size:1.6rem;color:" + GOLD + "}" +
    ".lx-acc h4{font-size:0.92rem;font-weight:600;margin-top:10px}" +
    ".lx-acc-price{color:" + GOLD + ";font-weight:600;margin:8px 0 12px}" +
    ".lx-acc button{padding:8px 20px;border-radius:999px;border:1px solid rgba(255,255,255,0.16);background:none;color:#e8e6e1;font-size:0.78rem;cursor:pointer;transition:border-color 0.25s,color 0.25s}" +
    ".lx-acc button:hover{border-color:" + GOLD + ";color:" + GOLD + "}" +
    ".lx-featgrid{display:grid;grid-template-columns:repeat(4,1fr);gap:24px;text-align:center}" +
    ".lx-feat-icon{font-size:1.8rem;color:" + GOLD + "}" +
    ".lx-featgrid h4{margin-top:12px;font-size:0.95rem}" +
    ".lx-featgrid p{color:#9aa4ae;font-size:0.82rem;margin-top:6px;line-height:1.5}" +
    ".lx-reviews{display:grid;grid-template-columns:repeat(3,1fr);gap:16px;margin-top:60px}" +
    ".lx-review{background:#151b22;border:1px solid rgba(255,255,255,0.06);border-radius:16px;padding:24px}" +
    ".lx-stars{color:" + GOLD + ";letter-spacing:2px}" +
    ".lx-review p{color:#b8c0c8;font-size:0.88rem;margin-top:12px;line-height:1.6}" +
    ".lx-review span{display:block;margin-top:14px;color:#707a84;font-size:0.78rem}" +
    ".lx-footer{border-top:1px solid rgba(255,255,255,0.06);padding:60px 0 40px;background:#0d1116}" +
    ".lx-fgrid{display:grid;grid-template-columns:repeat(4,1fr);gap:30px}" +
    ".lx-fgrid h5{font-size:0.85rem;letter-spacing:0.08em;color:" + GOLD + ";margin-bottom:14px}" +
    ".lx-fgrid a{display:block;color:#9aa4ae;font-size:0.85rem;padding:4px 0;cursor:pointer;text-decoration:none}" +
    ".lx-fgrid a:hover{color:#e8e6e1}" +
    ".lx-copy{text-align:center;color:#707a84;font-size:0.8rem;margin-top:44px}" +
    ".lx-cart-overlay{position:fixed;inset:0;background:rgba(0,0,0,0.55);z-index:90;opacity:0;pointer-events:none;transition:opacity 0.35s}" +
    ".lx-cart-overlay.open{opacity:1;pointer-events:auto}" +
    ".lx-cart{position:fixed;top:0;right:0;height:100%;width:380px;max-width:92vw;background:#151b22;z-index:100;padding:26px;transform:translateX(105%);transition:transform 0.4s cubic-bezier(0.22,1,0.36,1);display:flex;flex-direction:column;border-left:1px solid rgba(255,255,255,0.08)}" +
    ".lx-cart.open{transform:translateX(0)}" +
    ".lx-cart-head{display:flex;justify-content:space-between;align-items:center;margin-bottom:22px}" +
    ".lx-cart-head h3{font-size:1.1rem}" +
    ".lx-cart-close{background:none;border:none;color:#9aa4ae;font-size:1.3rem;cursor:pointer}" +
    ".lx-cart-items{flex:1;overflow-y:auto}" +
    ".lx-cart-item{display:flex;justify-content:space-between;align-items:center;padding:14px 0;border-bottom:1px solid rgba(255,255,255,0.06);font-size:0.9rem}" +
    ".lx-cart-item small{display:block;color:#9aa4ae;margin-top:3px}" +
    ".lx-cart-rm{background:none;border:none;color:#707a84;cursor:pointer;font-size:0.8rem}" +
    ".lx-cart-rm:hover{color:#e07a7a}" +
    ".lx-cart-total{display:flex;justify-content:space-between;padding:18px 0;font-weight:600;border-top:1px solid rgba(255,255,255,0.1);margin-top:10px}" +
    ".lx-empty{color:#707a84;text-align:center;margin-top:40px;font-size:0.9rem}" +
    ".lx-page{max-width:760px;margin:0 auto;padding:80px 20px}" +
    ".lx-page h2{font-size:1.8rem;margin-bottom:6px}" +
    ".lx-page .lx-sub{text-align:left;margin:6px 0 40px}" +
    ".lx-order{background:#151b22;border:1px solid rgba(255,255,255,0.06);border-radius:16px;padding:22px;margin-bottom:14px;display:flex;justify-content:space-between;align-items:center;flex-wrap:wrap;gap:10px}" +
    ".lx-order small{display:block;color:#9aa4ae;margin-top:4px;font-size:0.8rem}" +
    ".lx-status{font-size:0.75rem;padding:5px 14px;border-radius:999px;border:1px solid rgba(95,208,138,0.4);color:#5fd08a}" +
    ".lx-status-ship{border-color:rgba(201,169,106,0.4);color:" + GOLD + "}" +
    ".lx-back{background:none;border:none;color:" + GOLD + ";cursor:pointer;font-size:0.88rem;margin-bottom:26px}" +
    ".lx-co-box{background:#151b22;border:1px solid rgba(255,255,255,0.06);border-radius:16px;padding:24px;margin-bottom:18px}" +
    ".lx-co-box h3{font-size:1.05rem;margin-bottom:16px}" +
    ".lx-co-row{display:flex;justify-content:space-between;padding:9px 0;border-bottom:1px solid rgba(255,255,255,0.05);font-size:0.9rem;color:#b8c0c8}" +
    ".lx-co-total{display:flex;justify-content:space-between;padding-top:14px;font-weight:600;font-size:1rem}" +
    ".lx-input{width:100%;padding:13px 16px;border-radius:12px;border:1px solid rgba(255,255,255,0.12);background:#101418;color:#e8e6e1;font-size:0.95rem;margin-bottom:12px;font-family:inherit}" +
    ".lx-input:focus{outline:none;border-color:" + GOLD + "}" +
    ".lx-spot-box{background:linear-gradient(160deg,#151b22,#122029);border:1px solid rgba(201,169,106,0.35);border-radius:16px;padding:24px;margin-bottom:18px}" +
    ".lx-spot-box h3{font-size:1.02rem}" +
    ".lx-spot-box .lx-spot-sub{color:#9aa4ae;font-size:0.82rem;margin:6px 0 16px;line-height:1.5}" +
    ".lx-spot-btn{width:100%;padding:12px;border-radius:12px;background:" + GOLD + ";color:#101418;font-weight:600;border:none;cursor:pointer;font-size:0.9rem}" +
    ".lx-spot-res{margin-top:14px;background:#101418;border:1px solid rgba(201,169,106,0.25);border-radius:12px;padding:16px;font-size:0.86rem;line-height:1.7;color:#b8c0c8;animation:lx-fadein 0.5s ease}" +
    "@keyframes lx-fadein{0%{opacity:0;transform:translateY(8px)}100%{opacity:1;transform:translateY(0)}}" +
    ".lx-verified{display:block;margin-top:10px;color:#5fd08a;font-size:0.76rem}" +
    ".lx-reveal{opacity:0;transform:translateY(28px);transition:opacity 0.8s ease,transform 0.8s ease}" +
    ".lx-reveal.visible{opacity:1;transform:translateY(0)}" +
    "@media(max-width:860px){.lx-grid4,.lx-featgrid,.lx-reviews{grid-template-columns:repeat(2,1fr)}.lx-fgrid{grid-template-columns:repeat(2,1fr)}.lx-nav{display:none}}" +
    "@media(max-width:640px){.lx-grid3{gap:8px}.lx-card{padding:20px 10px}.lx-price{font-size:1.2rem}.lx-feats{font-size:0.7rem}}";

  function Reveal(props) {
    var ref = useRef(null);
    var visState = useState(false);
    var vis = visState[0];
    var setVis = visState[1];
    useEffect(function () {
      var node = ref.current;
      if (!node) return;
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            setVis(true);
            obs.unobserve(en.target);
          }
        });
      }, { threshold: 0.12 });
      obs.observe(node);
      return function () { obs.disconnect(); };
    }, []);
    return e("div", { ref: ref, className: "lx-reveal" + (vis ? " visible" : "") }, props.children);
  }

  function Bubbles() {
    var items = [];
    for (var i = 0; i < 16; i++) {
      var size = 6 + ((i * 7) % 22);
      items.push(e("div", {
        key: i,
        className: "lx-bubble",
        style: {
          width: size + "px",
          height: size + "px",
          left: ((i * 61) % 100) + "%",
          animationDuration: (7 + ((i * 3) % 9)) + "s",
          animationDelay: ((i * 0.9) % 8) + "s"
        }
      }, e("div", {
        className: "lx-bubble-in",
        style: { animationDuration: (1.5 + ((i * 0.4) % 2)) + "s" }
      })));
    }
    return e(React.Fragment, null, items);
  }

  var PRODUCTS = [
    {
      id: "wave", name: "LUNG X Wave", tag: "Der Einstieg", price: 289, compare: null, hero: false, scarce: null,
      feats: ["0,5L Zylinder", "Bis zu 28 Min. Tauchzeit", "Handpumpe inklusive", "14 Tage R\u00fcckgaberecht"]
    },
    {
      id: "odyssey", name: "LUNG X Odyssey", tag: "Das komplette Erlebnis", price: 349, compare: 429, hero: true, scarce: "Nur noch 7 Sets verf\u00fcgbar",
      feats: ["0,5L Premium-Zylinder", "Bis zu 28 Min. Tauchzeit", "Handpumpe & Tragetasche", "Ersatz-Mundst\u00fcck", "Spot Finder Premium-Zugang"]
    },
    {
      id: "drift", name: "LUNG X Drift", tag: "Solide Ausstattung", price: 329, compare: null, hero: false, scarce: null,
      feats: ["0,5L Zylinder", "Bis zu 28 Min. Tauchzeit", "Handpumpe & Tragetasche", "14 Tage R\u00fcckgaberecht"]
    }
  ];

  var ACCESSORIES = [
    { id: "cyl", icon: "\u26f1", name: "Ersatz-Zylinder 0,5L", price: 89 },
    { id: "pump", icon: "\u2699", name: "Hochdruck-Handpumpe", price: 49 },
    { id: "bag", icon: "\u2605", name: "Premium Tragetasche", price: 39 },
    { id: "mouth", icon: "\u2693", name: "Ersatz-Mundst\u00fcck (2er)", price: 19 }
  ];

  // ===== Shopify Theme Editor Anbindung (Blocks) =====
  if (S.products && S.products.length) {
    PRODUCTS = S.products.map(function (p, idx) {
      return {
        id: "p" + idx,
        name: p.name,
        tag: p.tag,
        price: p.price,
        compare: p.old || null,
        hero: !!p.popular,
        scarce: null,
        feats: p.features || []
      };
    });
  }
  if (S.accessories && S.accessories.length) {
    var ACC_ICONS = ["\u26f1", "\u2699", "\u2605", "\u2693"];
    ACCESSORIES = S.accessories.map(function (a, idx) {
      return { id: "a" + idx, icon: ACC_ICONS[idx % 4], name: a.name, price: a.price };
    });
  }
  // ===================================================

  var FEATURES = [
    { icon: "\u23f1", title: "28 Minuten Freiheit", text: "Eine F\u00fcllung, fast eine halbe Stunde Unterwasserwelt \u2014 ganz ohne Ausbildung." },
    { icon: "\u2693", title: "0,5L Premium-Zylinder", text: "Aluminium in Luftfahrtqualit\u00e4t. Kompakt, leicht, langlebig." },
    { icon: "\u21ba", title: "14 Tage R\u00fcckgabe", text: "Nicht \u00fcberzeugt? Volle Erstattung, ohne Fragen." },
    { icon: "\u2713", title: "Gepr\u00fcfte Sicherheit", text: "Jede Flasche einzeln druckgepr\u00fcft und zertifiziert." }
  ];

  var REVIEWS = [
    { name: "Markus T.", text: "Auf Kreta die sch\u00f6nsten Riffe erkundet \u2014 ohne Tauchschein. Unglaubliches Gef\u00fchl von Freiheit." },
    { name: "Lena W.", text: "Das Odyssey-Set war jeden Euro wert. Verarbeitung wie von Apple, alles durchdacht." },
    { name: "Jonas K.", text: "28 Minuten klingen kurz \u2014 unter Wasser ist es eine Ewigkeit. Absolute Empfehlung." }
  ];

  if (S.testimonials && S.testimonials.length) {
    REVIEWS = S.testimonials.map(function (t) {
      var txt = (t[0] || "").replace(/^[\u201e"]+/, "").replace(/[\u201c"]+$/, "");
      return { name: t[1] || "", text: txt };
    });
  }

  var ORDERS = [
    { id: "#LX-10248", date: "12. Juli 2026", items: "LUNG X Odyssey", total: 349, status: "Zugestellt", ship: false },
    { id: "#LX-10312", date: "16. Juli 2026", items: "Ersatz-Zylinder 0,5L, Ersatz-Mundst\u00fcck (2er)", total: 108, status: "Versandt", ship: true }
  ];

  var SPOTS = [
    "\ud83d\udc20 Gesch\u00fctzte Bucht mit flachem Riff \u2014 frei zug\u00e4nglich",
    "\ud83c\udf0a Klarwasser-Strand, perfekt f\u00fcr 0,5L-Tauchg\u00e4nge",
    "\ud83e\udea8 Schnorchel- & Tauchspot mit Sichtweite 15m+"
  ];

  function SpotFinder() {
    var valState = useState("");
    var val = valState[0]; var setVal = valState[1];
    var resState = useState(null);
    var res = resState[0]; var setRes = resState[1];
    function find() {
      var v = val.trim();
      if (!v) { setRes(null); return; }
      var days = 2 + Math.floor(Math.random() * 4);
      setRes({ place: v, days: days });
    }
    return e("div", { className: "lx-spot-box" },
      e("h3", null, "\ud83c\udf34 Spot Finder \u2014 dein Urlaubsort"),
      e("div", { className: "lx-spot-sub" }, "Gib deinen Urlaubsort ein \u2014 wir zeigen dir die sch\u00f6nsten frei zug\u00e4nglichen Str\u00e4nde und Unterwasser-Spots, gegengepr\u00fcft \u00fcber TikTok & Reddit."),
      e("input", {
        className: "lx-input",
        placeholder: "z. B. Mallorca, Kreta, Hurghada \u2026",
        value: val,
        onChange: function (ev) { setVal(ev.target.value); },
        onKeyDown: function (ev) { if (ev.key === "Enter") find(); }
      }),
      e("button", { className: "lx-spot-btn", onClick: find }, "Spots anzeigen"),
      res ? e("div", { className: "lx-spot-res" },
        e("strong", { style: { color: GOLD } }, "Top-Spots rund um " + res.place),
        e("div", { style: { marginTop: "8px" } },
          SPOTS.map(function (s, i) { return e("div", { key: i }, s); })
        ),
        e("span", { className: "lx-verified" }, "\u2713 Verifiziert \u00fcber TikTok & Reddit \u00b7 letzter Post vor " + res.days + " Tagen")
      ) : null
    );
  }

  function App() {
    var loadedState = useState(false);
    var loaded = loadedState[0]; var setLoaded = loadedState[1];
    var pageState = useState("shop");
    var page = pageState[0]; var setPage = pageState[1];
    var cartOpenState = useState(false);
    var cartOpen = cartOpenState[0]; var setCartOpen = cartOpenState[1];
    var cartState = useState([]);
    var cart = cartState[0]; var setCart = cartState[1];
    var doneState = useState(false);
    var done = doneState[0]; var setDone = doneState[1];

    useEffect(function () {
      var t = setTimeout(function () { setLoaded(true); }, 60);
      return function () { clearTimeout(t); };
    }, []);

    function addToCart(item) {
      setCart(cart.concat([{ key: Date.now() + Math.random(), name: item.name, price: item.price }]));
      setCartOpen(true);
    }
    function removeFromCart(key) {
      setCart(cart.filter(function (i) { return i.key !== key; }));
    }
    function goto(p) {
      setPage(p);
      setDone(false);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
    function scrollToId(id) {
      if (page !== "shop") {
        setPage("shop");
        setTimeout(function () { var n = document.getElementById(id); if (n) n.scrollIntoView({ behavior: "smooth" }); }, 120);
        return;
      }
      var n = document.getElementById(id);
      if (n) n.scrollIntoView({ behavior: "smooth" });
    }

    var total = cart.reduce(function (s, i) { return s + i.price; }, 0);

    var header = e("header", { className: "lx-header" },
      e("div", { className: "lx-wrap lx-header-in" },
        e("div", { className: "lx-logo", onClick: function () { goto("shop"); } }, "LUNG ", e("span", null, "X")),
        e("nav", { className: "lx-nav" },
          e("a", { onClick: function () { scrollToId("lx-products"); } }, "Sets"),
          e("a", { onClick: function () { scrollToId("lx-accessories"); } }, "Zubeh\u00f6r"),
          e("a", { onClick: function () { scrollToId("lx-features"); } }, "Warum LUNG X"),
          e("a", { onClick: function () { goto("account"); } }, "Konto")
        ),
        e("button", { className: "lx-cartbtn", onClick: function () { setCartOpen(true); } },
          "Warenkorb",
          cart.length > 0 ? e("span", { className: "lx-cartcount" }, String(cart.length)) : null
        )
      )
    );

    var hero = e("section", { className: "lx-hero" },
      e(Bubbles, null),
      e("div", { className: "lx-wrap", style: { position: "relative", zIndex: 2 } },
        e("h1", null, (S.heroTitle1 || "Atme Freiheit.") + " ", e("span", null, S.heroTitle2 || "Erlebe die Tiefe.")),
        e("p", null, S.heroSub || "Bis zu 28 Minuten unter Wasser \u2014 an den sch\u00f6nsten Orten deines Urlaubs. Ohne Ausbildung, ohne Grenzen."),
        e("button", { className: "lx-cta", onClick: function () { scrollToId("lx-products"); } }, S.heroCta || "Jetzt entdecken"),
        e("div", { className: "lx-usps" },
          e("span", null, "\u2713 14 Tage R\u00fcckgaberecht"),
          e("span", null, "\u2713 Bis zu 28 Min. Tauchzeit"),
          e("span", null, "\u2713 0,5L Premium-Zylinder")
        )
      )
    );

    var products = e("section", { className: "lx-section", id: "lx-products" },
      e("div", { className: "lx-wrap" },
        e(Reveal, null,
          e("h2", { className: "lx-title" }, S.productsTitle || "W\u00e4hle dein Erlebnis"),
          e("p", { className: "lx-sub" }, S.productsSub || "Drei Sets. Ein Versprechen: die Unterwasserwelt geh\u00f6rt dir.")
        ),
        e(Reveal, null,
          e("div", { className: "lx-grid3" },
            PRODUCTS.map(function (p) {
              return e("div", { key: p.id, className: "lx-card" + (p.hero ? " lx-card-hero" : "") },
                p.hero ? e("div", { className: "lx-badge" }, "\u2605 Meistgew\u00e4hlt") : null,
                e("div", { className: "lx-pname" }, p.name),
                e("div", { className: "lx-ptag" }, p.tag),
                e("div", { className: "lx-price" }, String(p.price) + " \u20ac"),
                p.compare ? e("div", { className: "lx-compare" }, String(p.compare) + " \u20ac") : e("div", { className: "lx-compare" }, "\u00a0"),
                e("ul", { className: "lx-feats" },
                  p.feats.map(function (f, i) { return e("li", { key: i }, "\u2713 " + f); })
                ),
                p.scarce ? e("div", { className: "lx-scarce" }, p.scarce) : null,
                e("button", {
                  className: "lx-buy" + (p.hero ? " lx-buy-solid" : ""),
                  onClick: function () { addToCart(p); }
                }, "In den Warenkorb")
              );
            })
          )
        )
      )
    );

    var accessories = e("section", { className: "lx-section", id: "lx-accessories", style: { paddingTop: 0 } },
      e("div", { className: "lx-wrap" },
        e(Reveal, null,
          e("h2", { className: "lx-title" }, "Zubeh\u00f6r"),
          e("p", { className: "lx-sub" }, "Alles, was dein Erlebnis perfekt macht.")
        ),
        e(Reveal, null,
          e("div", { className: "lx-grid4" },
            ACCESSORIES.map(function (a) {
              return e("div", { key: a.id, className: "lx-acc" },
                e("div", { className: "lx-acc-icon" }, a.icon),
                e("h4", null, a.name),
                e("div", { className: "lx-acc-price" }, String(a.price) + " \u20ac"),
                e("button", { onClick: function () { addToCart(a); } }, "Hinzuf\u00fcgen")
              );
            })
          )
        )
      )
    );

    var features = e("section", { className: "lx-section", id: "lx-features", style: { background: "#0d1116" } },
      e("div", { className: "lx-wrap" },
        e(Reveal, null,
          e("h2", { className: "lx-title" }, "Warum LUNG X"),
          e("p", { className: "lx-sub" }, "Kompromisslos durchdacht \u2014 vom ersten Atemzug an.")
        ),
        e(Reveal, null,
          e("div", { className: "lx-featgrid" },
            FEATURES.map(function (f, i) {
              return e("div", { key: i },
                e("div", { className: "lx-feat-icon" }, f.icon),
                e("h4", null, f.title),
                e("p", null, f.text)
              );
            })
          )
        ),
        e(Reveal, null,
          e("div", { className: "lx-reviews" },
            REVIEWS.map(function (r, i) {
              return e("div", { key: i, className: "lx-review" },
                e("div", { className: "lx-stars" }, "\u2605\u2605\u2605\u2605\u2605"),
                e("p", null, "\u201e" + r.text + "\u201c"),
                e("span", null, r.name + " \u00b7 Verifizierter Kauf")
              );
            })
          )
        )
      )
    );

    var footer = e("footer", { className: "lx-footer" },
      e("div", { className: "lx-wrap" },
        e("div", { className: "lx-fgrid" },
          e("div", null,
            e("h5", null, "LUNG X"),
            e("a", { onClick: function () { scrollToId("lx-products"); } }, "Sets"),
            e("a", { onClick: function () { scrollToId("lx-accessories"); } }, "Zubeh\u00f6r"),
            e("a", { onClick: function () { scrollToId("lx-features"); } }, "Warum LUNG X")
          ),
          e("div", null,
            e("h5", null, "SERVICE"),
            e("a", null, "14 Tage R\u00fcckgaberecht"),
            e("a", null, "Versand & Lieferung"),
            e("a", null, "Kontakt")
          ),
          e("div", null,
            e("h5", null, "KONTO"),
            e("a", { onClick: function () { goto("account"); } }, "Mein Konto"),
            e("a", { onClick: function () { goto("account"); } }, "Bestellhistorie"),
            e("a", { onClick: function () { setCartOpen(true); } }, "Warenkorb")
          ),
          e("div", null,
            e("h5", null, "RECHTLICHES"),
            e("a", null, "Impressum"),
            e("a", null, "Datenschutz"),
            e("a", null, "AGB")
          )
        ),
        e("div", { className: "lx-copy" }, "\u00a9 2026 LUNG X \u2014 Atme Freiheit. Erlebe die Tiefe.")
      )
    );

    var accountPage = e("div", { className: "lx-page" },
      e("button", { className: "lx-back", onClick: function () { goto("shop"); } }, "\u2190 Zur\u00fcck zum Shop"),
      e("h2", null, "Mein Konto"),
      e("p", { className: "lx-sub" }, "Willkommen zur\u00fcck. Hier findest du deine Bestellungen."),
      ORDERS.map(function (o) {
        return e("div", { key: o.id, className: "lx-order" },
          e("div", null,
            e("strong", null, o.id),
            e("small", null, o.items),
            e("small", null, o.date + " \u00b7 " + String(o.total) + " \u20ac")
          ),
          e("span", { className: "lx-status" + (o.ship ? " lx-status-ship" : "") }, o.status)
        );
      })
    );

    var checkoutPage = e("div", { className: "lx-page" },
      e("button", { className: "lx-back", onClick: function () { goto("shop"); } }, "\u2190 Zur\u00fcck zum Shop"),
      e("h2", null, "Kasse"),
      e("p", { className: "lx-sub" }, "Fast geschafft \u2014 dein Erlebnis wartet."),
      e("div", { className: "lx-co-box" },
        e("h3", null, "Bestelldetails"),
        cart.length === 0
          ? e("div", { className: "lx-empty", style: { margin: "10px 0" } }, "Dein Warenkorb ist leer.")
          : e(React.Fragment, null,
              cart.map(function (i) {
                return e("div", { key: i.key, className: "lx-co-row" },
                  e("span", null, i.name),
                  e("span", null, String(i.price) + " \u20ac")
                );
              }),
              e("div", { className: "lx-co-total" },
                e("span", null, "Gesamt"),
                e("span", { style: { color: GOLD } }, String(total) + " \u20ac")
              )
            )
      ),
      e(SpotFinder, null),
      e("div", { className: "lx-co-box" },
        e("h3", null, "Lieferadresse"),
        e("input", { className: "lx-input", placeholder: "Vor- und Nachname" }),
        e("input", { className: "lx-input", placeholder: "Stra\u00dfe und Hausnummer" }),
        e("input", { className: "lx-input", placeholder: "PLZ und Ort" }),
        e("input", { className: "lx-input", placeholder: "E-Mail-Adresse" })
      ),
      done
        ? e("div", { className: "lx-spot-res", style: { textAlign: "center" } },
            e("strong", { style: { color: GOLD } }, "Danke f\u00fcr deine Bestellung!"),
            e("div", { style: { marginTop: "6px" } }, "Du erh\u00e4ltst in K\u00fcrze eine Best\u00e4tigung per E-Mail.")
          )
        : e("button", {
            className: "lx-cta",
            style: { width: "100%", marginTop: "4px" },
            onClick: function () { if (cart.length > 0) { setDone(true); setCart([]); } }
          }, "Jetzt kaufen")
    );

    var cartDrawer = e(React.Fragment, null,
      e("div", { className: "lx-cart-overlay" + (cartOpen ? " open" : ""), onClick: function () { setCartOpen(false); } }),
      e("aside", { className: "lx-cart" + (cartOpen ? " open" : "") },
        e("div", { className: "lx-cart-head" },
          e("h3", null, "Warenkorb"),
          e("button", { className: "lx-cart-close", onClick: function () { setCartOpen(false); } }, "\u00d7")
        ),
        e("div", { className: "lx-cart-items" },
          cart.length === 0
            ? e("div", { className: "lx-empty" }, "Dein Warenkorb ist leer.")
            : cart.map(function (i) {
                return e("div", { key: i.key, className: "lx-cart-item" },
                  e("div", null, i.name, e("small", null, String(i.price) + " \u20ac")),
                  e("button", { className: "lx-cart-rm", onClick: function () { removeFromCart(i.key); } }, "Entfernen")
                );
              })
        ),
        e("div", { className: "lx-cart-total" },
          e("span", null, "Gesamt"),
          e("span", { style: { color: GOLD } }, String(total) + " \u20ac")
        ),
        e("button", {
          className: "lx-cta",
          style: { width: "100%", marginTop: "6px" },
          onClick: function () { setCartOpen(false); goto("checkout"); }
        }, "Zur Kasse")
      )
    );

    var body;
    if (page === "account") { body = accountPage; }
    else if (page === "checkout") { body = checkoutPage; }
    else { body = e(React.Fragment, null, hero, products, accessories, features); }

    return e("div", {
      style: {
        opacity: loaded ? 1 : 0,
        transform: loaded ? "translateY(0)" : "translateY(16px)",
        transition: "opacity 0.9s ease, transform 0.9s ease"
      }
    },
      e("style", null, css),
      header,
      body,
      footer,
      cartDrawer
    );
  }

  var rootNode = document.getElementById("lungx-root");
  if (rootNode) {
    ReactDOM.createRoot(rootNode).render(e(App, null));
  }
})();